﻿class ia extends Tango.Component {
	widgetDidMount() {
		const ctrl = document.getElementById(this.root);
		const container = this.props.cu.getThisOrParent(ctrl, function (n) { return n.hasAttribute && n.hasAttribute('data-c-prefix'); });
		const prfx = container.getAttribute('data-c-prefix');

		const valEl = document.getElementById(prfx + '_validation');
		const formEl = document.getElementById(prfx + '_form');

		const au = this.props.au;
		ctrl.onclick = function () {
			const sfx = Date.now();
			const msgId = prfx + '_timemsg_' + sfx;
			valEl.innerHTML = '<div id="' + msgId + '"></div>';

			setTimeout(function () {
				const resultEl = document.getElementById(prfx + '_result');
				const msgEl = document.getElementById(msgId);
				if (msgEl && !(resultEl && resultEl.innerHTML)) {
					const k = ctrl.getAttribute('data-mintime');
					const m = ctrl.getAttribute('data-maxtime');
					var msg = '<i class="icon icon-warning" style="margin-right: 4px; color:yellow"><svg class="svgicon-warning"><use xlink:href="/data/icons/svg#icon-warning"></use></svg></i>';
					msg += 'Среднее время построения данного отчета ' + k +
						' секунд. В периоды повышенной нагрузки на систему отчет может строиться до ' + m +
						' минут. Просим не закрывать страницу и дождаться окончания формирования отчета.';
					msgEl.innerHTML = '<div style="padding:8px">' + msg + '</div>';
				}
			}, 30000);

			au.formSubmit(ctrl, formEl); 
		};
	}
};

Tango.registerComponent(ia, sp => ({
	cu: sp.commonUtils,
	au: sp.ajaxUtils
}));